document.addEventListener('DOMContentLoaded', function(){
  checked();
})


// function checked() {
//   const warrantyCheckbox = document.querySelector('.bundly__details .warranty-checkbox');

//   // Helper function to get a cookie value by name
//   function getCookie(name) {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(';').shift();
//     return null;
//   }

//   // Ensure the element exists before adding the event listener
//   if (warrantyCheckbox) {
//     // Check the cookie value on page load
//     const cookieValue = getCookie('kidamento_care');
//     const isChecked = cookieValue === 'true';  // Check if the cookie value is 'true'

//     // Set the checkbox based on the cookie value
//     warrantyCheckbox.checked = isChecked;
//     warrantyCheckbox.setAttribute('prop', isChecked ? 'true' : 'false');

//     console.log(`Initial prop value from cookie: ${warrantyCheckbox.getAttribute('prop')}`);
//     console.log(`Initial checkbox state from cookie: ${warrantyCheckbox.checked}`);

//     // Event listener for checkbox click
//     warrantyCheckbox.addEventListener('click', function() {
//       const isChecked = warrantyCheckbox.checked;
      
//       // Update the `prop` attribute based on the checked state
//       warrantyCheckbox.setAttribute('prop', isChecked ? 'true' : 'false');
      
//       // Set the cookie with the checked state
//       document.cookie = `kidamento_care=${isChecked ? 'true' : 'false'}; path=/; max-age=31536000`;  // 1 year expiry

//       console.log(`prop value is now: ${warrantyCheckbox.getAttribute('prop')}`);
//       console.log(`Cookie set: kidamento_care=${isChecked ? 'true' : 'false'}`);
//     });
//   }
// };

function checked() {
  const warrantyCheckbox = document.querySelector('.bundly__details .warranty-checkbox');
  const warrantyPrice = document.querySelector('.warranty-price');  // Select the warranty price element

  // Helper function to get a cookie value by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Ensure the element exists before adding the event listener
  if (warrantyCheckbox) {
    // Check the cookie value on page load
    const cookieValue = getCookie('kidamento_care');
    const isChecked = cookieValue === 'true';  // Check if the cookie value is 'true'

    // Set the checkbox based on the cookie value
    warrantyCheckbox.checked = isChecked;
    warrantyCheckbox.setAttribute('prop', isChecked ? 'true' : 'false');

    console.log(`Initial prop value from cookie: ${warrantyCheckbox.getAttribute('prop')}`);
    console.log(`Initial checkbox state from cookie: ${warrantyCheckbox.checked}`);

    // Hide the .warranty-price element if the checkbox is unchecked
    if (!isChecked && warrantyPrice) {
      warrantyPrice.style.display = 'none';
    }

    // Event listener for checkbox click
    warrantyCheckbox.addEventListener('click', function() {
      const isChecked = warrantyCheckbox.checked;
      
      // Update the `prop` attribute based on the checked state
      warrantyCheckbox.setAttribute('prop', isChecked ? 'true' : 'false');
      
      // Set the cookie with the checked state
      document.cookie = `kidamento_care=${isChecked ? 'true' : 'false'}; path=/; max-age=31536000`;  // 1 year expiry

      console.log(`prop value is now: ${warrantyCheckbox.getAttribute('prop')}`);
      console.log(`Cookie set: kidamento_care=${isChecked ? 'true' : 'false'}`);

      // Show or hide the .warranty-price element based on checkbox state
      if (!isChecked && warrantyPrice) {
        warrantyPrice.style.display = 'none';
      } else if (warrantyPrice) {
        warrantyPrice.style.display = 'block';  // Show the warranty price if checked
      }
    });
  }
};

checked();

document.addEventListener('bundlyBlocksUpdated', function() {
  let fullyFinallyPrice = null;
  let warrantyDivFinally = document.querySelector('.warranty-price');
  let finallyNewPrice = document.querySelector('.bundly__bundle_new_price');
  let filterPrice = parseFloat(finallyNewPrice.textContent.replace(/[^0-9.]/g, ''));
  
  function updateWarrantyPrice() {
  const newPriceElement = document.querySelector('.bundly__bundle_new_price');
  const warrantyDiv = document.querySelector('.warranty-price');
  const percentageSpan = parseInt($('.kidamento_care').html());

    if (newPriceElement && warrantyDiv && percentageSpan) {
      // Get the original bundle price
      let originalPrice = parseFloat(newPriceElement.textContent.replace(/[^0-9.]/g, ''));

      // Calculate the ideal warranty price (percentage-based)
      let warrantyPrice = originalPrice * percentageSpan / 100;
      warrantyPrice = parseFloat(warrantyPrice.toFixed(2));

      console.log("Calculated warranty price:", warrantyPrice);

      // Now find the nearest available warranty variant
      let nearestValue = null;
      let nearestVariantId = null;
      let smallestDiff = Infinity;

      document.querySelectorAll('.Warranty_outer option').forEach(option => {
        const varTitle = parseFloat(option.getAttribute('var_title'));
        const dataPrice = parseFloat(option.getAttribute('data_price'));
        const variantId = option.value;

        if (!isNaN(varTitle)) {
          const diff = Math.abs(varTitle - warrantyPrice);
          if (diff < smallestDiff) {
            smallestDiff = diff;
            nearestValue = dataPrice;
            fullyFinallyPrice=nearestValue;
            nearestVariantId = variantId;
          }
        }
      });

      // Display the nearest variant price
      if (nearestValue !== null) {
        if(filterPrice >0 ){
        warrantyDiv.innerHTML = `$${nearestValue.toFixed(2)}`;
         console.log("Nearest variant price:", nearestValue);
        }
   

        // Update .card_product with selected variant ID
        const cardProduct = document.querySelector('.card_product');
        if (cardProduct) {
          cardProduct.setAttribute('data-id', nearestVariantId);
        }
      } else {
        // Fallback if no match found
         if(filterPrice >0 ){
        warrantyDiv.innerHTML = `$${warrantyPrice.toFixed(2)}`;
         }
      }
    }
  
  }

  function fetchCart() {
      checked();
    // Fetch the cart data when the document is ready
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            console.log(data.items);  // Logs all the items in the cart

            // Loop through cart items and check for "extended-warranty"
            data.items.forEach(item => {
                console.log("item_handle:", item.handle);
                console.log("item_price:", item.price);

                // If the handle matches "extended-warranty", store the price
                if (item.handle === "extended-warranty") {
                    extendedWarrantyPrice = item.price/100;  // Set the extended warranty price
                    combinedFinallyPrice = extendedWarrantyPrice + fullyFinallyPrice;
                    let nearestValue1 = null;
                    let nearestVariantId1 = null;
                    let smallestDiff1 = Infinity;
                     document.querySelectorAll('.Warranty_outer option').forEach(option => {
                      const varTitle1 = parseFloat(option.getAttribute('var_title'));
                      const dataPrice1 = parseFloat(option.getAttribute('data_price'));
                      const variantId1 = option.value;

                      if (!isNaN(varTitle1)) {
                        const diff1 = Math.abs(varTitle1 - combinedFinallyPrice);
                        if (diff1 < smallestDiff1) {
                          smallestDiff1 = diff1;
                          nearestValue1 = dataPrice1;
                          nearestVariantId1 = variantId1;
                        }
                      }
                    });
                                  console.log("Extended Warranty Price:", nearestValue1);
                             if(filterPrice >0 ){
                    warrantyDivFinally.innerHTML = `$${nearestValue1.toFixed(2)}`;
                             };
                };
              });
        });
  };
 
setTimeout(()=>{
  updateWarrantyPrice();
    checked();
  fetchCart();
},2000)
    //*********************  cart currency image on load start   *********************//
        var imgCurr = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("src");
        var currName = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("alt");
        
        document.querySelector(".bundly__custom_liquid .popout__toggle img").setAttribute("src", imgCurr);
        document.querySelector(".bundly__custom_liquid .popout__toggle .currency-name").textContent = currName;
     //*********************  cart currency image on load end   *********************//

      //*********************  cart currency change start   *********************//
          document.querySelectorAll("li.custom-cart-list a.popout-list__option").forEach(function(element) {
            element.addEventListener("click", function() {
                var current = this.getAttribute("data-value");
                var popoutInput = document.querySelector("li.currency-lists a.popout-list__option[data-value='" + current + "']");
                if (popoutInput) {
                    var event = new Event("theme:popout:click");
                    popoutInput.dispatchEvent(event);
                }
          });
        });
       //*********************  cart currency change end   *********************//

      //*********************  checkout button start   *********************//
        document.querySelectorAll(".bundly__custom_liquid .bundle-checkout-jtpl").forEach(function(item) {
            item.addEventListener("click", function() {
                var addToCartButton = document.querySelector(".template-bundly .bundly__block form .bundly__add_to_cart_button");
                addToCartButton.setAttribute("data-redirect-to-cart", "false");

                var scriptOne = document.querySelector(".template-bundly .bundly__block form .bundly__custom_liquid .script-one");
                if (scriptOne) {
                    scriptOne.remove();
                }

                setTimeout(function() {
                    addToCartButton.click();
                    window.location.href = "/checkout";
                }, 900);
            });
         });
      //*********************  checkout button end   *********************//
   
    //************************** Update Compare at price start *****************************//
       function updateBundleOriginalCompareAtPrice() {
            let totalCompareAtPrice = 0;
            let selectedVariants = $('.bundly__selected_variant');
            
            selectedVariants.each(function () {
                const compareAtStr = $(this).data('variant-compare-at-price');
                const compareAtV = $(this).data('variant-price');
                const compareAt = parseFloat(compareAtStr);
                const compareAtS = parseFloat(compareAtV);
                console.log('compareAt', compareAt);
                if (!isNaN(compareAt)) {
                    totalCompareAtPrice += compareAt;
                }else{
                  totalCompareAtPrice += compareAtS;
                }
            });
        
            if (selectedVariants.length > 0) {
                let currencySymbol = $(".main_container_bundle").attr("data-currency-symbol") || "€";
                let totalFormatted = (totalCompareAtPrice / 100).toFixed(2);
              
                // const formattedPrice = currencySymbol === "€" || currencySymbol === '¥'
                //     ? totalFormatted.replace('.', ',')
                //     : totalFormatted;
              const formattedPrice = currencySymbol === '€'
                  ? totalFormatted.replace('.', ',')
                    // : totalFormatted;
                  : currencySymbol === '¥'
                    ? Number(totalFormatted).toLocaleString('ja-JP') // For JPY: ¥18,500
                    : totalFormatted;
                console.log("formattedPrice"+formattedPrice);
                $('.bundly__bundle_original_price').text(currencySymbol + formattedPrice);
            } else {
                
                 $('.bundly__price').hide();
            }
        }
    //************************** Update Compare at price start *****************************//
          let product_id = '';
      document.querySelectorAll(".bundly__add_to_bundle_button").forEach(function(button) {
          button.addEventListener("click", function() {
    //************************** Update Compare at price start *****************************//
        updateBundleOriginalCompareAtPrice();
     /****************************** Update Compare at price end ****************************/
            
          //*************************** bundle quanity (3/3) start ****************// 
          
            if($("body").hasClass("camera-bag-book")){
             var text = $('.bundly__details_heading_count_left').text().trim();
              if(text == '(3)'){
                  $('.bundly__details_heading_count_left').text('(3/3)');
              }
            }

            if($("body").hasClass("camera-bag")){
             var text = $('.bundly__details_heading_count_left').text().trim();
              if(text == '(2)'){
                  $('.bundly__details_heading_count_left').text('(2/2)');
              }
            }
            
            if($("body").hasClass("camera-book")){
             var text = $('.bundly__details_heading_count_left').text().trim();
              if(text == '(2)'){
                  $('.bundly__details_heading_count_left').text('(2/2)');
              }
            }
          //*************************** bundle quanity (3/3) end ****************// 
            
              let model_p = "Model P";
              let prd_text = this.closest(".bundly__component_grid_item[data-component-index='0']").querySelector(".bundly__component_info .bundly__product_custom_data").textContent;
      
              if (model_p === prd_text) {
                  let id = this.getAttribute("data-variant-id");
                  product_id = id;
                  document.body.classList.add("model-p-product");
                 setCookie("product_id", product_id, 7);
                // console.log(product_id);
                
              } else {
                  product_id = '';
                  document.body.classList.remove("model-p-product");
                deleteCookie("product_id");
              }
          });
      });
       updateBundleOriginalCompareAtPrice();
      document.querySelectorAll(".bundly__slot_remove").forEach(function(button) {
          button.addEventListener("click", function() {
            // console.log("remove click updated");
             var cookieValue = getCookie('product_id');
              let pro_text = this.closest(".bundly__slot_component").querySelector(".bundly__slot").getAttribute("data-variant-id");
              if (cookieValue === pro_text) {
                  product_id = '';
                  document.body.classList.remove("model-p-product");
                 deleteCookie("product_id");
              }
          });
      });


     CANDYRACK_VARIANT_SELECTOR_FUNCTION = (btn) => {
          var GetCookieValue = getCookie('product_id');
          console.log("GetCookieValue");
          console.log(GetCookieValue);
            if(GetCookieValue){
              setTimeout(function(){
                console.log("Getframe on updated");
                var iframe = document.getElementById('candyrack-frame');
                var iframeBody = iframe.contentWindow.document.body;
              iframeBody.classList.add('new-class');
             }, 2300);
            }

          deleteCookie("bundle_camera");
          deleteCookie("bundle_bag");
          deleteCookie("bundle_book");
          deleteCookie("bundlebag_camera");
          deleteCookie("bundlebag_bag");
          deleteCookie("bundlebook_camera");
          deleteCookie("bundlebook_book");
          deleteCookie("product_id");
        };


      //************************** set cookie start ***************************// 
      if($("body").hasClass("camera-bag-book")){
        $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button").click(function(){
          var var_id1 =  $(this).attr("data-variant-id");
            console.log(var_id1);
            setCookie("bundle_camera", var_id1, 7);
        });
        $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button").click(function(){
          var var_id2 =  $(this).attr("data-variant-id");
            console.log(var_id2);
              setCookie("bundle_bag", var_id2, 7);
        });
        $(".bundly__component_grid_item[data-component-index='2'] .bundly__add_to_bundle_button").click(function(){
          var var_id3 =  $(this).attr("data-variant-id");
            console.log(var_id3);
              setCookie("bundle_book", var_id3, 7);
        });
      }
      
      if($("body").hasClass("camera-bag")){
        $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button").click(function(){
          var var_id1 =  $(this).attr("data-variant-id");
            console.log(var_id1);
            setCookie("bundlebag_camera", var_id1, 7);
        });
        $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button").click(function(){
          var var_id2 =  $(this).attr("data-variant-id");
            console.log(var_id2);
              setCookie("bundlebag_bag", var_id2, 7);
        });
      }
      
      if($("body").hasClass("camera-book")){
        $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button").click(function(){
          var var_id1 =  $(this).attr("data-variant-id");
            console.log(var_id1);
            setCookie("bundlebook_camera", var_id1, 7);
        });
        $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button").click(function(){
          var var_id2 =  $(this).attr("data-variant-id");
            console.log(var_id2);
              setCookie("bundlebook_book", var_id2, 7);
        });
      }
      
  
      
       //************************** set cookie end ***************************// 

  //************************** on load cookie click start ***************************//
    if($("body").hasClass("camera-bag-book")){
        var bundle_camera = getCookie('bundle_camera');
        var bundle_bag= getCookie('bundle_bag');
        var bundle_book = getCookie('bundle_book');
      $(".bundly__add_to_bundle_button").each(function(){
        // $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_camera + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_bag + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='2'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_book + "']").trigger("click");
      });
    }

     if($("body").hasClass("camera-bag")){
        var bundle_camera = getCookie('bundlebag_camera');
        var bundle_bag= getCookie('bundlebag_bag');
  
      $(".bundly__add_to_bundle_button").each(function(){
        // $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_camera + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_bag + "']").trigger("click");
      });       
     }
    
     if($("body").hasClass("camera-book")){
        var bundle_camera = getCookie('bundlebook_camera');
        var bundle_book= getCookie('bundlebook_book');
  
      $(".bundly__add_to_bundle_button").each(function(){
        // $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_camera + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_book + "']").trigger("click");
      });       
     }
   //************************** on load cookie click end ***************************//

  //************************** remove button cookie click start ***************************//
      if($("body").hasClass("camera-bag-book")){
        $(".bundly__slot_remove[data-component-index='0']").click(function(){
          deleteCookie("bundle_camera");
        });
        $(".bundly__slot_remove[data-component-index='1']").click(function(){
          deleteCookie("bundle_bag");
        });
        $(".bundly__slot_remove[data-component-index='2']").click(function(){
          deleteCookie("bundle_book");
        });
      }
      if($("body").hasClass("camera-bag")){
        $(".bundly__slot_remove[data-component-index='0']").click(function(){
          deleteCookie("bundlebag_camera");
        });
        $(".bundly__slot_remove[data-component-index='1']").click(function(){
          deleteCookie("bundlebag_bag");
        });        
      }
      if($("body").hasClass("camera-book")){
        $(".bundly__slot_remove[data-component-index='0']").click(function(){
          deleteCookie("bundlebook_camera");
        });
        $(".bundly__slot_remove[data-component-index='1']").click(function(){
          deleteCookie("bundlebook_book");
        });        
      }
  //**************************  remove button cookie click end ***************************//

   //*****************************  Mobile cart scroll start   ******************************//
   if($(window).width() <= 768){
     scrollBundle();
     $(".bundly__details").addClass("bundly__details--visible");
   }
   $(window).resize(function(){
    if($(window).width() <= 768){
      scrollBundle();
      $(".bundly__details").addClass("bundly__details--visible");
    }
   });
  function scrollBundle(){
    if($("body").hasClass("camera-bag-book")){
      $('.bundly__add_to_bundle_button[data-component-index="2"]').click(function(){
        var targetElement = $('.bundly__details_content');
        setTimeout(function(){
        $('html, body').animate({
            scrollTop: targetElement.offset().top
          }, 1000);
        }, 50);
      });
    } else{
      $('.bundly__add_to_bundle_button[data-component-index="1"]').click(function(){
        var targetElement = $('.bundly__details_content');
        setTimeout(function(){
        $('html, body').animate({
            scrollTop: targetElement.offset().top
          }, 1000);
        }, 50);
      });
    }
  }
   //*****************************  Mobile cart scroll end   ******************************//

   // ***************************Price Discount start ****************// 

         function applyBundleDiscounts() {
            let globalBundleDiscount = 0;
        
            // Get discount percentage
            const bundleDiscountText = $('.bundly__bundle_discount_type').text().trim();
            const bundleDiscountMatch = bundleDiscountText.match(/(\d+)%/);
        
            if (bundleDiscountMatch) {
                globalBundleDiscount = parseInt(bundleDiscountMatch[1], 10);
            }
            // Get current currency and symbol
            let currencySymbol = $(".main_container_bundle").attr("data-currency-symbol");
            let currencyCode = $(".selected-currency").text().trim(); 
            if (!currencySymbol) {
                const firstPrice = $(".money").first().text().trim();
                const match = firstPrice.match(/^[^\d]+/);
                currencySymbol = match ? match[0] : "$";
            }
            $('.bundly__component_grid_item').each(function () {
                const $priceContainer = $(this).find('.bundly__component_prices');
                const $originalPriceEl = $priceContainer.find('.bundly__component_original_price');
                const originalPriceText = $originalPriceEl.text().trim();
                const priceMatch = originalPriceText.match(/[\d,.]+/);
                const numeric = priceMatch ? priceMatch[0].replace(',', '.') : null;
                let originalPrice = numeric ? parseFloat(numeric) : NaN;
        
                if (!isNaN(originalPrice) && globalBundleDiscount > 0) {
                    if (!$originalPriceEl.attr('data-original-price')) {
                        $originalPriceEl.attr('data-original-price', priceMatch);
                    } else {
                        originalPrice = parseFloat($originalPriceEl.attr('data-original-price'));
                    }
        
                    const discounted = (originalPrice * (1 - globalBundleDiscount / 100));
        
                    // Format price: comma for EUR, dot otherwise
                    const formattedPrice = currencySymbol === '¥'
                    ? discounted.toFixed(3).replace('.', ',')   
                    : (currencySymbol === '€'
                        ? discounted.toFixed(2).replace('.', ',')  
                        : discounted.toFixed(2)); 
        
                    $originalPriceEl.text(currencySymbol + formattedPrice);
                }
            });
        }
        applyBundleDiscounts();

      
      // ***************************Price Discount end ****************//
   
     //**** Update Compare at price *****//
      updateBundleOriginalCompareAtPrice();
    //**** Update Compare at price*****//
  
  });

//************************** Update Compare at price start *****************************//
  function updateBundleOriginalCompareAtPrice() {
        let totalCompareAtPrice = 0;
        let selectedVariants = $('.bundly__selected_variant');
        
        selectedVariants.each(function () {
            const compareAtStr = $(this).data('variant-compare-at-price');
           const compareAtV = $(this).data('variant-price');
            const compareAt = parseFloat(compareAtStr);
            const compareAtS = parseFloat(compareAtV);
            console.log('compareAt', compareAt);
            if (!isNaN(compareAt)) {
                totalCompareAtPrice += compareAt;
            }else{
              totalCompareAtPrice += compareAtS;
            }
        });
    
        if (selectedVariants.length > 0) {
            let currencySymbol = $(".main_container_bundle").attr("data-currency-symbol") || "€";
            let totalFormatted = (totalCompareAtPrice / 100).toFixed(2);
            const formattedPrice = currencySymbol === "€" || currencySymbol === "¥"
                ? totalFormatted.replace('.', ',')
                : totalFormatted;
            $('.bundly__bundle_original_price').text(currencySymbol + formattedPrice);
        } else {
            
             $('.bundly__price').hide();
        }
    }
    updateBundleOriginalCompareAtPrice();
 /** **************************** Update Compare at price end ****************************/
    
  document.addEventListener('DOMContentLoaded', function() {

//************************** Update Compare at price start *****************************//
      function updateBundleOriginalCompareAtPrice() {
            let totalCompareAtPrice = 0;
            let selectedVariants = $('.bundly__selected_variant');
            
            selectedVariants.each(function () {
                const compareAtStr = $(this).data('variant-compare-at-price');
                 const compareAtV = $(this).data('variant-price');
                const compareAt = parseFloat(compareAtStr);
                const compareAtS = parseFloat(compareAtV);
                console.log('compareAt', compareAt);
                if (!isNaN(compareAt)) {
                    totalCompareAtPrice += compareAt;
                }else{
                  totalCompareAtPrice += compareAtS;
                }
            });
        
            if (selectedVariants.length > 0) {
                let currencySymbol = $(".main_container_bundle").attr("data-currency-symbol") || "€";
                let totalFormatted = (totalCompareAtPrice / 100).toFixed(2);
                // const formattedPrice = currencySymbol === "€" || currencySymbol === "¥"
                //     ? totalFormatted.replace('.', ',')
                //     : totalFormatted;
              const formattedPrice = currencySymbol === '€'
                  ? totalFormatted.replace('.', ',')
                    // : totalFormatted;
                  : currencySymbol === '¥'
                    ? Number(totalFormatted).toLocaleString('ja-JP') 
                    : totalFormatted;
                $('.bundly__bundle_original_price').text(currencySymbol + formattedPrice);
            } else {
                
                 $('.bundly__price').hide();
            }
        }
        updateBundleOriginalCompareAtPrice();
     /****************************** Update Compare at price end ****************************/
    
   //*********************  cart currency image on load start   *********************//
        var imgCurr = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("src");
        var currName = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("alt");
        
        document.querySelector(".bundly__custom_liquid .popout__toggle img").setAttribute("src", imgCurr);
        document.querySelector(".bundly__custom_liquid .popout__toggle .currency-name").textContent = currName;
     //*********************  cart currency image on load end   *********************//

    //*********************  cart currency change start   *********************//
          document.querySelectorAll("li.custom-cart-list a.popout-list__option").forEach(function(element) {
            element.addEventListener("click", function() {
                var current = this.getAttribute("data-value");
                var popoutInput = document.querySelector("li.currency-lists a.popout-list__option[data-value='" + current + "']");
                if (popoutInput) {
                    var event = new Event("theme:popout:click");
                    popoutInput.dispatchEvent(event);
                }
            });
        });
       //*********************  cart currency change end   *********************//

    //*********************  checkout button start   *********************//
        document.querySelectorAll(".bundly__custom_liquid .bundle-checkout-jtpl").forEach(function(item) {
            item.addEventListener("click", function() {
                var addToCartButton = document.querySelector(".template-bundly .bundly__block form .bundly__add_to_cart_button");
                addToCartButton.setAttribute("data-redirect-to-cart", "false");

                var scriptOne = document.querySelector(".template-bundly .bundly__block form .bundly__custom_liquid .script-one");
                if (scriptOne) {
                    scriptOne.remove();
                }

                setTimeout(function() {
                    addToCartButton.click();
                    window.location.href = "/checkout";
                }, 900);
            });
         });
      //*********************  checkout button end   *********************// 
      
    document.querySelectorAll(".bundly__slot_remove").forEach(function(button) {
      var CookieValue = getCookie('product_id');
              let pro_text = button.closest(".bundly__slot_component").querySelector(".bundly__slot").getAttribute("data-variant-id");
              if (CookieValue === pro_text) {
                  document.body.classList.add("model-p-product");
              }
          
      });

setTimeout(function(){
  console.log("success on load");
     CANDYRACK_VARIANT_SELECTOR_FUNCTION = (btn) => {
          var GetCookieValue = getCookie('product_id');
          console.log("GetCookieValue");
          console.log(GetCookieValue);
            if(GetCookieValue){
              setTimeout(function(){
                console.log("Getframe on load");
                var iframe = document.getElementById('candyrack-frame');
                var iframeBody = iframe.contentWindow.document.body;
              iframeBody.classList.add('new-class');
             }, 2300);
            }

        deleteCookie("bundle_camera");
        deleteCookie("bundle_bag");
        deleteCookie("bundle_book");
        deleteCookie("bundlebag_camera");
        deleteCookie("bundlebag_bag");
        deleteCookie("bundlebook_camera");
        deleteCookie("bundlebook_book");
        deleteCookie("product_id");
        };
     }, 1800);

        let product_id = '';
      document.querySelectorAll(".bundly__add_to_bundle_button").forEach(function(button) {
          button.addEventListener("click", function() {

  //************************** Update Compare at price start *****************************//
        updateBundleOriginalCompareAtPrice();
     /****************************** Update Compare at price end ****************************/

    //*************************** bundle quanity (3/3) start ****************// 
            if($("body").hasClass("camera-bag-book")){
             var text = $('.bundly__details_heading_count_left').text().trim();
              if(text == '(3)'){
                  $('.bundly__details_heading_count_left').text('(3/3)');
              }
            }

            if($("body").hasClass("camera-bag")){
             var text = $('.bundly__details_heading_count_left').text().trim();
              if(text == '(2)'){
                  $('.bundly__details_heading_count_left').text('(2/2)');
              }
            }
            
            if($("body").hasClass("camera-book")){
             var text = $('.bundly__details_heading_count_left').text().trim();
              if(text == '(2)'){
                  $('.bundly__details_heading_count_left').text('(2/2)');
              }
            }            
  //*************************** bundle quanity (3/3) end ****************//
            
              let model_p = "Model P";
              let prd_text = this.closest(".bundly__component_grid_item[data-component-index='0']").querySelector(".bundly__component_info .bundly__product_custom_data").textContent;
      
              if (model_p === prd_text) {
                  let id = this.getAttribute("data-variant-id");
                  product_id = id;
                  document.body.classList.add("model-p-product");
                 setCookie("product_id", product_id, 7);
                // console.log(product_id);
                
              } else {
                  product_id = '';
                  document.body.classList.remove("model-p-product");
                deleteCookie("product_id");
              }
      

          });
      });
      updateBundleOriginalCompareAtPrice();
      document.querySelectorAll(".bundly__slot_remove").forEach(function(button) {
          button.addEventListener("click", function() {
             console.log("remove click loaded");
             var cookieValue = getCookie('product_id');
              let prop_text = this.closest(".bundly__slot_component").querySelector(".bundly__slot").getAttribute("data-variant-id");
              if (cookieValue === prop_text) {
                console.log("remove loaded");
                  document.body.classList.remove("model-p-product");
                 deleteCookie("product_id");
              }
          });
      });

    
  //************************** set cookie start ***************************// 
    if($("body").hasClass("camera-bag-book")){
      $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button").click(function(){
        var var_id1 =  $(this).attr("data-variant-id");
          console.log(var_id1);
          setCookie("bundle_camera", var_id1, 7);
      });
      $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button").click(function(){
        var var_id2 =  $(this).attr("data-variant-id");
          console.log(var_id2);
            setCookie("bundle_bag", var_id2, 7);
      });
      $(".bundly__component_grid_item[data-component-index='2'] .bundly__add_to_bundle_button").click(function(){
        var var_id3 =  $(this).attr("data-variant-id");
          console.log(var_id3);
            setCookie("bundle_book", var_id3, 7);
      });
    }
    
    if($("body").hasClass("camera-bag")){
            $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button").click(function(){
        var var_id1 =  $(this).attr("data-variant-id");
          console.log(var_id1);
          setCookie("bundlebag_camera", var_id1, 7);
      });
      $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button").click(function(){
        var var_id2 =  $(this).attr("data-variant-id");
          console.log(var_id2);
            setCookie("bundlebag_bag", var_id2, 7);
      });
    }
    
    if($("body").hasClass("camera-book")){
            $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button").click(function(){
        var var_id1 =  $(this).attr("data-variant-id");
          console.log(var_id1);
          setCookie("bundlebook_camera", var_id1, 7);
      });
      $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button").click(function(){
        var var_id2 =  $(this).attr("data-variant-id");
          console.log(var_id2);
            setCookie("bundlebook_bag", var_id2, 7);
      });
    }
  //************************** set cookie end ***************************// 
      
//************************** on load cookie click start ***************************//
    if($("body").hasClass("camera-bag-book")){
      var bundle_camera = getCookie('bundle_camera');
      var bundle_bag= getCookie('bundle_bag');
      var bundle_book = getCookie('bundle_book');

      $(".bundly__add_to_bundle_button").each(function(){
        // $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_camera + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_bag + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='2'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_book + "']").trigger("click");
      });
   }
    
     if($("body").hasClass("camera-bag")){
        var bundle_camera = getCookie('bundlebag_camera');
        var bundle_bag= getCookie('bundlebag_bag');
  
      $(".bundly__add_to_bundle_button").each(function(){
        // $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_camera + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_bag + "']").trigger("click");
      });       
     }
    
     if($("body").hasClass("camera-book")){
        var bundle_camera = getCookie('bundlebook_camera');
        var bundle_book= getCookie('bundlebook_book');
  
      $(".bundly__add_to_bundle_button").each(function(){
        // $(".bundly__component_grid_item[data-component-index='0'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_camera + "']").trigger("click");
        
        // $(".bundly__component_grid_item[data-component-index='1'] .bundly__add_to_bundle_button[data-variant-id='" + bundle_book + "']").trigger("click");
      });       
     }
//************************** on load cookie click end ***************************// 

//************************** remove button cookie click start ***************************//
   if($("body").hasClass("camera-bag-book")){ 
      $(".bundly__slot_remove[data-component-index='0']").click(function(){
        deleteCookie("bundle_camera");
      });
      $(".bundly__slot_remove[data-component-index='1']").click(function(){
        deleteCookie("bundle_bag");
      });
      $(".bundly__slot_remove[data-component-index='2']").click(function(){
        deleteCookie("bundle_book");
      });
   }

    if($("body").hasClass("camera-bag")){
      $(".bundly__slot_remove[data-component-index='0']").click(function(){
        deleteCookie("bundlebag_camera");
      });
      $(".bundly__slot_remove[data-component-index='1']").click(function(){
        deleteCookie("bundlebag_bag");
      });      
    }
    if($("body").hasClass("camera-book")){
      $(".bundly__slot_remove[data-component-index='0']").click(function(){
        deleteCookie("bundlebook_camera");
      });
      $(".bundly__slot_remove[data-component-index='1']").click(function(){
        deleteCookie("bundlebook_bag");
      });      
    }
//**************************  remove button cookie click end ***************************//

  //**************************  Mobile cart scroll start ***************************//
   if($(window).width() <= 768){
     $(".bundly__details").addClass("bundly__details--visible");
     scrollBundle();
   }
   $(window).resize(function(){
    if($(window).width() <= 768){
      $(".bundly__details").addClass("bundly__details--visible");
      scrollBundle();
    }
   });
  function scrollBundle(){
    if($("body").hasClass("camera-bag-book")){
      $('.bundly__add_to_bundle_button[data-component-index="2"]').click(function(){
        var targetElement = $('.bundly__details_content');
        setTimeout(function(){
          $('html, body').animate({
              scrollTop: targetElement.offset().top
            }, 500);
         }, 50);
        
      });
    } else{
      $('.bundly__add_to_bundle_button[data-component-index="1"]').click(function(){
        var targetElement = $('.bundly__details_content');
        setTimeout(function(){        
        $('html, body').animate({
            scrollTop: targetElement.offset().top
          }, 500);
         }, 50);        
      });
    }
  }
    //************************** Mobile cart scroll click end ***************************//
    
// *************************** bundle quanity (3/3) start ****************// 
      if($("body").hasClass("camera-bag-book")){
       var text = $('.bundly__details_heading_count_left').text().trim();
        if(text == '(3)'){
            $('.bundly__details_heading_count_left').text('(3/3)');
        }
      }

      if($("body").hasClass("camera-bag")){
       var text = $('.bundly__details_heading_count_left').text().trim();
        if(text == '(2)'){
            $('.bundly__details_heading_count_left').text('(2/2)');
        }
      }
      
      if($("body").hasClass("camera-book")){
       var text = $('.bundly__details_heading_count_left').text().trim();
        if(text == '(2)'){
            $('.bundly__details_heading_count_left').text('(2/2)');
        }
      }
//*************************** bundle quanity (3/3) end ****************// 
    
 //***************************Price Discount start ****************// 

         function applyBundleDiscounts() {
            let globalBundleDiscount = 0;
        
            // Get discount percentage
            const bundleDiscountText = $('.bundly__bundle_discount_type').text().trim();
            const bundleDiscountMatch = bundleDiscountText.match(/(\d+)%/);
        
            if (bundleDiscountMatch) {
                globalBundleDiscount = parseInt(bundleDiscountMatch[1], 10);
            }
            // Get current currency and symbol
            let currencySymbol = $(".main_container_bundle").attr("data-currency-symbol");
            let currencyCode = $(".selected-currency").text().trim(); 
            if (!currencySymbol) {
                const firstPrice = $(".money").first().text().trim();
                const match = firstPrice.match(/^[^\d]+/);
                currencySymbol = match ? match[0] : "$";
            }
            $('.bundly__component_grid_item').each(function () {
                const $priceContainer = $(this).find('.bundly__component_prices');
                const $originalPriceEl = $priceContainer.find('.bundly__component_original_price');
                const originalPriceText = $originalPriceEl.text().trim();
                const priceMatch = originalPriceText.match(/[\d,.]+/);
                const numeric = priceMatch ? priceMatch[0].replace(',', '.') : null;
                let originalPrice = numeric ? parseFloat(numeric) : NaN;        
                if (!isNaN(originalPrice) && globalBundleDiscount > 0) {
                    if (!$originalPriceEl.attr('data-original-price')) {
                        $originalPriceEl.attr('data-original-price', priceMatch);
                    } else {
                        originalPrice = parseFloat($originalPriceEl.attr('data-original-price'));
                    }
        
                    const discounted = (originalPrice * (1 - globalBundleDiscount / 100));
        
                    // Format price: comma for EUR, dot otherwise
                    const formattedPrice = currencySymbol === '¥'
                    ? discounted.toFixed(3).replace('.', ',')
                    : (currencySymbol === '€'
                        ? discounted.toFixed(2).replace('.', ',')  
                        : discounted.toFixed(2));
        
                    $originalPriceEl.text(currencySymbol + formattedPrice);
                }
            });
        }
        applyBundleDiscounts();
    // ***************************Price Discount end ****************//
    
  });

    
// let Interval;

// function startInterval() {
//   Interval = setInterval(bundle, 30);
// }

// function bundle() {
//     if ($(".template-bundly .bundly__block form .bundly__content").length > 0) {
      
//       //*********************  cart currency image on load start   *********************//
//         var imgCurr = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("src");
//         var currName = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("alt");
        
//         document.querySelector(".bundly__custom_liquid .popout__toggle img").setAttribute("src", imgCurr);
//         document.querySelector(".bundly__custom_liquid .popout__toggle .currency-name").textContent = currName;
//      //*********************  cart currency image on load end   *********************//

//        //*********************  cart currency change start   *********************//
//           document.querySelectorAll("li.custom-cart-list a.popout-list__option").forEach(function(element) {
//             element.addEventListener("click", function() {
//                 var current = this.getAttribute("data-value");
//                 var popoutInput = document.querySelector("li.currency-lists a.popout-list__option[data-value='" + current + "']");
//                 if (popoutInput) {
//                     var event = new Event("theme:popout:click");
//                     popoutInput.dispatchEvent(event);
//                 }
//             });
//         });
//        //*********************  cart currency change end   *********************//


//        //*********************  checkout button start   *********************//
//         document.querySelectorAll(".bundly__custom_liquid .bundle-checkout-jtpl").forEach(function(item) {
//             item.addEventListener("click", function() {
//                 var addToCartButton = document.querySelector(".template-bundly .bundly__block form .bundly__add_to_cart_button");
//                 addToCartButton.setAttribute("data-redirect-to-cart", "false");

//                 var scriptOne = document.querySelector(".template-bundly .bundly__block form .bundly__custom_liquid .script-one");
//                 if (scriptOne) {
//                     scriptOne.remove();
//                 }

//                 setTimeout(function() {
//                     addToCartButton.click();
//                     window.location.href = "/checkout";
//                 }, 900);
//             });
//          });
//          clearInterval(Interval);
//       //*********************  checkout button end   *********************//
//     }
// }

// startInterval();
// document.addEventListener("mousemove", function() {
//     clearInterval(Interval);
//     startInterval();
// });

// document.addEventListener("touchstart", function() {
//     clearInterval(Interval);
//     startInterval();
// });

    
//     const Interval = setInterval(bundle, 300);

// function bundle() {
//     if ($(".template-bundly .bundly__block form .bundly__content").length > 0) {
      
//       var imgCurr = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("src");
//     var currName = document.querySelector(".custom-jtpl-currency .popout__toggle img").getAttribute("alt");
//     document.querySelector(".bundly__custom_liquid .popout__toggle img").setAttribute("src", imgCurr);
//     document.querySelector(".bundly__custom_liquid .popout__toggle .currency-name").textContent = currName;
      
//       document.querySelectorAll(".bundly__custom_liquid .bundle-checkout-jtpl").forEach(function(item) {
//     item.addEventListener("click", function() {
//         var addToCartButton = document.querySelector(".template-bundly .bundly__block form .bundly__add_to_cart_button");
//         addToCartButton.setAttribute("data-redirect-to-cart", "false");

//         var scriptOne = document.querySelector(".template-bundly .bundly__block form .bundly__custom_liquid .script-one");
//         if (scriptOne) {
//             scriptOne.remove();
//         }

//         setTimeout(function() {
//             addToCartButton.click();
//             window.location.href = "/checkout";
//         }, 900);
//     });
// });
//         clearInterval(Interval);
//     }
// }
    
//     let product_id = '';
// document.querySelectorAll(".bundly__add_to_bundle_button").forEach(function(button) {
//     button.addEventListener("click", function() {
//         let model_p = "Model P";
//         let prd_text = this.closest(".bundly__component_info").querySelector(".bundly__product_custom_data").textContent;

//         if (model_p === prd_text) {
//             let id = this.getAttribute("data-variant-id");
//             product_id = id;
//             document.body.classList.add("model-p-product");
//         } else {
//             product_id = '';
//             document.body.classList.remove("model-p-product");
//         }

//         console.log(product_id);
//     });
// });

// document.querySelectorAll(".bundly__slot_remove").forEach(function(button) {
//     button.addEventListener("click", function() {
//         let pro_text = this.closest(".bundly__slot_component").querySelector(".bundly__slot").getAttribute("data-variant-id");

//         if (product_id === pro_text) {
//             product_id = '';
//             document.body.classList.remove("model-p-product");
//         }
//     });
// });
 function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to delete a cookie
function deleteCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999; path=/';
}
  
  function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for(let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}
